const productBundleFallbacks = new Map([['FBT-045375', 'a/bundles/salty-species-ht5w']]);

function repairProductBundleLinks(root = document) {
  const offerMarkers = [
    ...(root.matches?.('.gfbErrorMessage[data-offer-id]') ? [root] : []),
    ...(root.querySelectorAll?.('.gfbErrorMessage[data-offer-id]') || []),
  ];
  const shopRoot = window.Shopify?.routes?.root || '/';

  offerMarkers.forEach((marker) => {
    const fallbackPath = productBundleFallbacks.get(marker.dataset.offerId);
    const link = marker.closest('.gfbProductBundleUpsellWrapper')?.querySelector('.gfbProductBundleUpsellButton');
    const href = link?.getAttribute('href') || '';

    if (!fallbackPath || !link || (href && !href.includes('undefined'))) return;

    link.setAttribute('href', `${shopRoot}${fallbackPath}`);
  });
}

repairProductBundleLinks();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      repairProductBundleLinks(node);
    });
  });
}).observe(document.body, { childList: true, subtree: true });
